import React from 'react';
import { Link } from 'react-router-dom';

const LearnMore = () => {
  // Match the tropical-indigo color from the theme
  const purpleColor = "#8A84E2";
  
  return (
    <div className="min-h-screen flex flex-col bg-cover bg-center bg-no-repeat" 
         style={{ backgroundImage: "url('/images/leelo_login.jpg')" }}>
      <div className="p-6">
        <Link to="/" className="text-white hover:underline font-bold mb-8 inline-block">
          &larr; Back to Home
        </Link>
        
        <div className="max-w-4xl mx-auto mt-10 px-4 md:px-0 flex flex-col items-center">
          <div className="mb-6">
            <img 
              src="/images/leelo_logo_transparent_cropped.png" 
              alt="Leelo" 
              className="h-16 md:h-20"
            />
          </div>
          
          <h2 className="text-2xl md:text-3xl font-medium text-white mb-16 text-center">
            Your AI thought-partner—ready for 1-on-1 or group chats.
          </h2>
          
          {/* How it works card */}
          <div className="bg-white/20 backdrop-blur-sm rounded-3xl p-8 shadow-lg mb-16 w-full max-w-xl">
            <h3 className="text-4xl font-bold mb-6 text-white">
              How it works
            </h3>
            
            <div className="text-xl">
              <div className="flex mb-4">
                <span className="text-white font-bold w-6 flex-shrink-0">1.</span>
                <span className="text-white font-bold">Sign up with your phone number.</span>
              </div>
              <div className="flex mb-4">
                <span className="text-white font-bold w-6 flex-shrink-0">2.</span>
                <span className="text-white font-bold">Create an AI thought partner for solo chats or group conversations.</span>
              </div>
              <div className="flex mb-4">
                <span className="text-white font-bold w-6 flex-shrink-0">3.</span>
                <span className="text-white font-bold">Get their number and start texting!</span> 
              </div>
              <div className="flex mb-4">
                <span className="text-white font-bold w-6 flex-shrink-0">5.</span>
                <span className="text-white font-bold">Get matched with like-minded users (optional)</span>
              </div>
              
              <p className="mt-8 text-xl font-medium text-left" style={{ color: "#644FFF" }}>
                It's that simple. No app to download.<br />
                Just text messages. <span className="text-base">(See examples below 👇)</span>
              </p>
            </div>
          </div>
          
          {/* Example images side by side */}
          <div className="mb-16 w-full max-w-4xl">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
              {/* Solo Chat Example */}
              <div className="text-center">
                <h4 className="text-white text-xl font-bold mb-4">Solo Conversations</h4>
                <div className="mx-auto bg-white rounded-[40px] shadow-xl overflow-hidden border-8 border-white" style={{ maxWidth: "280px" }}>
                  <img 
                    src="/images/leelo_learn_more_example.png" 
                    alt="Solo chat with AI" 
                    className="max-w-full h-auto"
                  />
                </div>
                <p className="text-white/80 mt-4 text-sm max-w-xs mx-auto">
                  Private one-on-one conversations for personal reflection and exploration
                </p>
              </div>
              
              {/* Group Chat Example */}
              <div className="text-center">
                <h4 className="text-white text-xl font-bold mb-4">Group Conversations</h4>
                <div className="mx-auto bg-white rounded-[40px] shadow-xl overflow-hidden border-8 border-white" style={{ maxWidth: "280px" }}>
                  <img 
                    src="/images/leelo_group_messagin_example.png" 
                    alt="Group chat with AI and friends" 
                    className="max-w-full h-auto"
                  />
                </div>
                <p className="text-white/80 mt-4 text-sm max-w-xs mx-auto">
                  Collaborative discussions with friends where AI joins when mentioned
                </p>
              </div>
            </div>
          </div>
          
          {/* Description text */}
          <div className="text-white text-center max-w-2xl mx-auto mb-12">
            <div className="bg-white/20 backdrop-blur-sm rounded-xl p-8 mb-12 text-left">
              <h4 className="text-4xl font-bold mb-6 text-white">
                How Matching Works
              </h4>
              
              <div className="text-xl">
                <div className="flex mb-4">
                  <span className="text-white font-bold w-6 flex-shrink-0">1.</span>
                  <span className="text-white font-bold">Opt into matching in your profile.</span>
                </div>
                <div className="flex mb-4">
                  <span className="text-white font-bold w-6 flex-shrink-0">2.</span>
                  <span className="text-white font-bold">Either start or continue chatting with your AI thought partner.</span>
                </div>
                <div className="flex mb-4">
                  <span className="text-white font-bold w-6 flex-shrink-0">3.</span>
                  <span className="text-white font-bold">Text "@match" to your AI thought partner or click on "My Matches" on your profile.</span>
                </div>
                <div className="flex mb-4">
                  <span className="text-white font-bold w-6 flex-shrink-0">3.</span>
                  <span className="text-white font-bold">Get access to other like-minded users.</span>
                </div>

                
                <p className="mt-8 text-xl font-medium text-left" style={{ color: "#644FFF" }}>
                  Build your social network with people who complement you.
                </p>
              </div>
            </div>
            
            <Link 
              to="/signup" 
              className="bg-white text-tropical-indigo rounded-lg px-12 py-4 text-xl font-bold hover:opacity-90 inline-block"
            >
              Join Now
            </Link>
          </div>
        </div>
      </div>
      
      <footer className="mt-auto p-6 text-center text-white text-sm">
        2025 © Wenzi, Inc. 
        <span className="mx-2">•</span> 
        <Link to="/privacy" className="text-white hover:underline">
          Privacy Policy
        </Link>
        <span className="mx-2">•</span> 
        <Link to="/terms-of-use" className="text-white hover:underline">
          Terms of Use
        </Link>
      </footer>
    </div>
  );
};

export default LearnMore;
